import { render } from "./TagList.vue?vue&type=template&id=77ea8186"
import script from "./js/tagList.js?vue&type=script&lang=js&external"
export * from "./js/tagList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__